import React from 'react';

import { ManagePayoutOrders } from 'features/payout-orders';

export const AdminPayoutOrdersPage: React.FC = () => <ManagePayoutOrders />;
